import { createSelector } from 'reselect';
import getQuoteSelector from './getPaymentQuoteSelector';

export default createSelector([getQuoteSelector], (quote = null) => {
  return !!quote;
});
